/**
 * Not part of `i18n.ts`, which reaches the router, the route tree and the monolith's SST resources, so
 * no unit test could import it (same reason as `language-path.ts`).
 */
import type { PortalLocale } from '@worldcoo/monolith/portals';

/**
 * Pure catch-up: `changeLanguage` already wrote the cookie and applied `updateRouterLocale`, while a
 * rejection would file a board ticket (TEC-3888). The `context.locale === lang` guard stops an
 * out-of-order response dragging the context back to a language already left.
 */
export async function refreshRouterContextForLocale<TContext extends { locale: PortalLocale }>(
	lang: PortalLocale,
	context: { locale: PortalLocale } | undefined,
	fetchContext: (lang: PortalLocale) => Promise<TContext>,
): Promise<void> {
	let fresh: TContext;
	try {
		fresh = await fetchContext(lang);
	} catch {
		// The switch already took effect.
		return;
	}

	if (!context) return;
	if (context.locale !== lang) return;

	Object.assign(context, fresh);
}
